module.exports = __webpack_public_path__ + "media/images/top/common/img_voice_worry01-78de561636b47d18e9b0af599af44678.png";